
































import { Component, Vue } from "vue-property-decorator";
import Sidebar from "../components/Sidebar.vue";
import { store, StoreState } from "../store";
import { mapState } from "vuex";
import VueElementLoading from "vue-element-loading";
import { RotateSquare2 } from "vue-loading-spinner";

@Component({
  components: {
    Sidebar,
    RotateSquare2,
    VueElementLoading
  },
  computed: {    
      ...mapState({
        alert_loader: (state: StoreState) => state.dashboard.admin.admin_loader,
        'notifications': (state: StoreState) => state.dashboard.notifications,
        'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
        'contacts': (state: StoreState) =>state.dashboard.contacts
    })
  },
   mounted: function() {
        this.$data.notinction_loader=true
       // this.notifn_created();
      },
})
export default class Alerts extends Vue {
  data() {
    return {
      org_alerts: [],
      alerts: [],
      notinction_loader:false,
      isalertnotification:false,
      activetab:""
    };
  }

  created(){
     //this.notifn_created();
  }
		
		 
		readNotification(notification)
		{
			 if(notification.contact) {
         if ( !notification.contact.numbers)
				{
					notification.contact.numbers = {
							mobile: { number: notification.contact.first_name
								},
							main:[notification.contact.first_name]
					}
					notification.contact.address= {};
					notification.name=  notification.contact.first_name;
					notification.contact.hideEdit=true;
        }
        //alert(JSON.stringify(notification.contact))
          this.$store.commit('CHANGE_SELECTED_CONTACT', notification.contact);
             this.$emit('notification', notification.socketRoom); 
             this.$store.commit("SHOW_CONTACT_DETAIL", true);
             debugger
             if (notification.eventType=='vm')
             {
               this.$store.commit("SET_CONTACT_STATUS_VM", true);
               this.$store.commit("SET_NOTIFICATION_VM_ID", notification.id);
                this.$store.commit("SET_NOTIFICATION_VOICE", notification);
               if (!notification.read)
                {	
                  //this.$store.commit('DELETE_NOTIFICATION', {notificationId:notification.id});
                  //const success =  this.$store.dispatch('markVoicemailAsRead', notification.id);
                }
             }
             else{
              this.$store.commit('SET_FOCUSTEXT', notification.timetofocus_ontext);
              this.$store.dispatch('markNotificationAsRead', notification);
              this.$store.commit('DELETE_NOTIFICATION', {notificationId: notification.id});
             }


            // this.$emit('textmsgevent', notification.socketRoom);
            //alert(notification.socketRoom)
            this.$store.commit('SET_NUMBER_BEING_CALLED', notification.socketRoom);
           
          this.$data.notifications_open = true;
      let conta = JSON.stringify(notification.contact);           
      this.$store.commit("CHANGE_NOTIFICATION_CONTACT", conta);
      this.$data.activetab = "textmsg";
      this.$router.push('/ContactsInfo_sp2') ;
      this.$data.isalertnotification = true;
      this.$store.commit("SET_TEXTMESSAGETAB",this.$data.activetab)
			}
		}

}
